import { useRef } from "react";

import { useCardFunc } from "../../hooks";

import {
  Flex,
  Box,
  Img,
  Spacer,
  Center,
  SimpleGrid,
  Input,
  InputGroup,
  Button,
  useOutsideClick,
} from "@chakra-ui/react";

import { options, add, crossShort } from "../../assets";

import { Cards, CardText } from "./style";

export const CardColor = ({
  id,
  num,
  colorCode,
  name,
  create,
  addCard,
  deleteCard,
  handleNameChange,
  handleColorChange,
}) => {
  const {
    hovered,
    setHovered,
    toggleName,
    nameEdit,
    setNameEdit,
    colorEdit,
    setColorEdit,
    toggleColor,
  } = useCardFunc();

  const colorRef = useRef();
  const nameRef = useRef();

  useOutsideClick({
    ref: colorRef,
    handler: () => setColorEdit(false),
  });
  useOutsideClick({
    ref: nameRef,
    handler: () => setNameEdit(false),
  });

  return (
    <Flex
      width={{ base: "304px", md: "304px", lg: "395px" }}
      flexDir="column"
      key={id}
    >
      <Cards
        // width={{ md: "304px", lg: "395px" }}
        height={{ base: "360px", md: "360px", lg: "444px" }}
        // height="444px"
        p={{ base: "25px", md: "25px", lg: "30px" }}
        bg={create ? "#131215" : colorCode}
        borderTopRadius="6px"
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
      >
        <Flex align="center">
          <Box>
            <Img
              boxSize={{ base: "34px", md: "34px", lg: "40px" }}
              src={options}
              alt="opt"
            />
          </Box>
          <Spacer />
          <Box>
            <CardText
              fontSize={{ base: "22px", md: "22px", lg: "26px" }}
              lineHeight={{ base: "24px", md: "24px", lg: "32px" }}
              fontWeight="bold"
            >
              {create ? (
                "∞"
              ) : id !== 0 ? (
                hovered ? (
                  <button onClick={deleteCard} p={0} m={0}>
                    <Img
                      boxSize={{ base: "20px", md: "20px", lg: "30px" }}
                      src={crossShort}
                    />
                  </button>
                ) : (
                  `-0${num}`
                )
              ) : (
                `-0${num}`
              )}
            </CardText>
          </Box>
        </Flex>
        <Center height={{ base: "260px", md: "255px", lg: "328px" }}>
          {create ? (
            <button onClick={addCard}>
              <Img
                boxSize={{ base: "56px", md: "56px", lg: "68px" }}
                src={add}
                alt="+"
              />
            </button>
          ) : (
            <Flex flexDir="column" alignItems="center">
              <CardText
                fontFamily="'Poppins', sans-serif"
                fontWeight="bold"
                fontSize={{ base: "24px", md: "24px", lg: "28px" }}
                lineHeight={{ base: "24px", md: "24px", lg: "28px" }}
              >
                <Button
                  onKeyDown={(e) => toggleColor(e)}
                  colorScheme="black"
                  variant="link"
                  onClick={toggleColor}
                  fontFamily="'Poppins', sans-serif"
                  fontSize={{ base: "24px", md: "24px", lg: "28px" }}
                  lineHeight={{ base: "24px", md: "24px", lg: "28px" }}
                  fontWeight="bold"
                >
                  {colorEdit ? (
                    <div ref={colorRef}>
                      <InputGroup>
                        <Input
                          width="280px"
                          variant="flushed"
                          placeholder={colorCode.toUpperCase()}
                          onChange={(e) => handleColorChange(e, id)}
                        />
                        <Box
                          width={"35px"}
                          height={"35px"}
                          ml="12px"
                          border="1px solid #fff"
                          borderRadius="8px"
                          boxShadow="0px 4px 4px rgba(139, 139, 139, 0.4)"
                          _hover={{ cursor: "pointer" }}
                        >
                          <Input
                            type="color"
                            width={"35px"}
                            height={"35px"}
                            opacity="0"
                            onChange={(e) => handleColorChange(e, id)}
                            _hover={{ cursor: "pointer" }}
                          />
                        </Box>
                      </InputGroup>
                    </div>
                  ) : (
                    colorCode.toUpperCase()
                  )}
                </Button>
              </CardText>
            </Flex>
          )}
        </Center>
        <CardText
          mb="12px"
          fontSize={{ base: "22px", md: "22px", lg: "26px" }}
          lineHeight={{ base: "24px", md: "24px", lg: "32px" }}
        >
          {create ? (
            "Create"
          ) : (
            <Button
              onKeyDown={(e) => toggleName(e)}
              colorScheme="black"
              variant="link"
              onClick={toggleName}
              fontWeight="normal"
              fontSize={{ base: "22px", md: "22px", lg: "26px" }}
              lineHeight={{ base: "24px", md: "24px", lg: "32px" }}
            >
              {nameEdit ? (
                <div ref={nameRef}>
                  <Input
                    variant="flushed"
                    placeholder={name}
                    maxlength="20"
                    onChange={(e) => handleNameChange(e, id)}
                  />
                </div>
              ) : (
                name
              )}
            </Button>
          )}
        </CardText>
      </Cards>
      <SimpleGrid columns={4} spacing={0}>
        <Box
          height={{ base: "40px", md: "40px", lg: "60px" }}
          opacity=".8"
          bg={colorCode}
          borderBottomLeftRadius="6px"
        />
        <Box
          height={{ base: "40px", md: "40px", lg: "60px" }}
          opacity=".7"
          bg={colorCode}
        />
        <Box
          height={{ base: "40px", md: "40px", lg: "60px" }}
          opacity=".6"
          bg={colorCode}
        />
        <Box
          height={{ base: "40px", md: "40px", lg: "60px" }}
          opacity=".5"
          bg={colorCode}
          borderBottomRightRadius="6px"
        />
      </SimpleGrid>
    </Flex>
  );
};
